import axios from 'axios';
import { get } from 'lodash';
import React, { memo, useEffect, useState } from 'react';
import { Col, Container, Nav, Row } from 'react-bootstrap';
import ResponsiveHeader from '../../../shared/components/ResponsiveHeader';
import useBreakpoint, { SIZE_SM, SIZE_XS } from '../../../shared/hooks/useBreakpoint';
import Feed from './Feed';
import HaveMoreQuestions from './HaveMoreQuestions';
import QuestionsSection from './QuestionsSection';
import RecentBlogPosts from './RecentBlogPosts';
import { useTranslation } from 'react-i18next';

const sections = [
  {
    title: 'about_obviously',
    link: 'about-obviously',
    component: QuestionsSection,
    dataField: 'aboutObviously',
  },
  {
    title: 'working_with_obviously',
    link: 'working-with-obviously',
    component: QuestionsSection,
    dataField: 'workingWithObviously',
  },
  {
    title: 'payments_rewards',
    link: 'payments-rewards',
    component: QuestionsSection,
    dataField: 'paymentsRewards',
  },
  // {
  //   title: 'corgi_loyalty_program',
  //   link: 'corgi-loyalty-program',
  //   component: QuestionsSection,
  //   dataField: 'corgiLoyaltyProgram',
  // },
  {
    title: 'recent_blog_posts',
    link: 'recent-blog-posts',
    component: RecentBlogPosts,
    dataField: 'blogPosts'
  },
  {
    title: 'feed',
    link: 'feed',
    component: Feed
  },
  {
    title: 'more_questions',
    link: 'have-more-questions',
    component: HaveMoreQuestions
  }
];

const LearningCenter = memo((language) => {
  const breakpoint = useBreakpoint();
  const { t } = useTranslation();
  const [insights, setInsights] = useState({
    blogPosts: [],
    aboutObviously: [],
    // corgiLoyaltyProgram: [],
    paymentsRewards: [],
    workingWithObviously: []
  });

  useEffect(() => {
    axios.get('/api/v1/static/insights').then(({ data }) => {
      const faqs = get(data, 'insights.faqs') || [];
      const blogPosts = get(data, 'insights.blog_posts') || [];
      const aboutObviously = [];
      // const corgiLoyaltyProgram = [];
      const paymentsRewards = [];
      const workingWithObviously = [];
      faqs.forEach(faq => {
        switch (faq.category) {
          // case "corgi_loyalty_program":
          //   corgiLoyaltyProgram.push(faq);
          //   break;
          case "about_obviously":
            aboutObviously.push(faq);
            break;
          case "payment_&_rewards":
            paymentsRewards.push(faq);
            break;
          case "working_with_obviously":
            workingWithObviously.push(faq);
            break;
        }
      });

      setInsights({
        blogPosts,
        aboutObviously,
        // corgiLoyaltyProgram,
        paymentsRewards,
        workingWithObviously
      });
    });
  }, [language]);

  return (<Container>
    <ResponsiveHeader className='mb-4' xs='h3' md='h2'>
      {t('influencers.pages.learning_center.title')}
    </ResponsiveHeader>

    <Row >
      <Col xs={12} md={4}>
        <Nav className="flex-column">
          {sections.map(section => (
            <Nav.Link key={section.link} href={`#${section.link}`} className="px-0" >
              {t(`influencers.pages.learning_center.${section.title}`)}
            </Nav.Link>
          ))}
        </Nav>
      </Col>

      {
        [SIZE_XS, SIZE_SM].includes(breakpoint) &&
        <Col xs={12}>
          <hr className='no-margin mt-4 mb-6' />
        </Col>
      }

      <Col xs={12} md={8}>
        {
          sections.map(section => {
            const Component = section.component;
            return Component ? <Component
              key={section.link}
              id={section.link}
              title={t(`influencers.pages.learning_center.${section.title}`)}
              data={get(insights, section.dataField)}
            /> : null;
          })
        }
      </Col>
    </Row >
  </Container >);
});

export default LearningCenter;
